import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";

// core components
import boxShadows from "assets/theme/box-shadow.js";

function CardToDoList() {
  const theme = useTheme();
  const [state, setState] = React.useState([
    {
      name: "Call with Dave",
      time: "10:30 AM",
      checked: true,
      color: "success",
    },
    {
      name: "Launch meeting",
      time: "10:30 AM",
      checked: false,
      color: "warning",
    },
    {
      name: "Argon Dashboard Launch",
      time: "10:30 AM",
      checked: false,
      color: "info",
    },
    {
      name: "Winter Hackathon",
      time: "10:30 AM",
      checked: true,
      color: "error",
    },
  ]);
  const sxGridItem = {
    successGridItemRoot: {
      backgroundColor: theme.palette.success.main + "!important",
    },
    warningGridItemRoot: {
      backgroundColor: theme.palette.warning.main + "!important",
    },
    infoGridItemRoot: {
      backgroundColor: theme.palette.info.main + "!important",
    },
    errorGridItemRoot: {
      backgroundColor: theme.palette.error.main + "!important",
    },
  };
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
        elevation={0}
      >
        <CardHeader
          subheader="To do list"
          subheaderTypographyProps={{
            component: Box,
            variant: "h3",
            sx: { marginBottom: "0!important", color: theme.palette.dark.main },
          }}
        ></CardHeader>
        <CardContent sx={{ padding: "0!important" }}>
          <List disablePadding>
            {state.map((prop, key) => {
              return (
                <ListItem
                  key={key}
                  sx={{
                    padding: "1.35rem 1.5rem!important",
                    "&:not(:last-of-type)": {
                      borderBottom: "1px solid " + theme.palette.gray[200],
                    },
                  }}
                >
                  <Grid container component={Box} sx={{ alignItems: "center" }}>
                    <Grid
                      item
                      sx={{
                        flexBasis: 0,
                        flexGrow: 1,
                        maxWidth: "100%",
                        position: "relative",
                        paddingLeft: "2rem",
                        "&:before": {
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "3px",
                          height: "100%",
                          content: "''",
                          borderRadius: "8px",
                          marginLeft: ".75rem",
                          ...sxGridItem[prop.color + "GridItemRoot"],
                        },
                      }}
                    >
                      {prop.checked ? (
                        <>
                          <Typography
                            variant="h5"
                            component="h5"
                            sx={{
                              marginBottom: 0,
                              textDecoration: "line-through",
                            }}
                          >
                            {prop.name}
                          </Typography>
                          <Box
                            sx={{
                              fontSize: "80%",
                              fontWeight: "400",
                              textDecoration: "line-through",
                            }}
                            component="small"
                          >
                            {prop.time}
                          </Box>
                        </>
                      ) : (
                        <>
                          <Typography
                            variant="h5"
                            component="h5"
                            sx={{
                              marginBottom: 0,
                            }}
                          >
                            {prop.name}
                          </Typography>
                          <Box
                            sx={{ fontSize: "80%", fontWeight: "400" }}
                            component="small"
                          >
                            {prop.time}
                          </Box>
                        </>
                      )}
                    </Grid>
                    <Grid item xs="auto">
                      <Checkbox
                        checked={prop.checked}
                        onChange={() => {
                          let newState = state.map((stateProp, stateKey) => {
                            if (key === stateKey) {
                              return {
                                key: stateKey,
                                ...stateProp,
                                checked: !prop.checked,
                              };
                            }
                            return stateProp;
                          });
                          setState(newState);
                        }}
                        inputProps={{ "aria-label": "primary checkbox" }}
                        color={prop.color}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </CardContent>
      </Card>
    </>
  );
}

export default CardToDoList;
